import { Box, BoxProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import arrayMove from 'array-move';
import cx from 'classnames';
import React from 'react';
import { SortableContainer as sortableContainer, SortableElement as sortableElement } from 'react-sortable-hoc';
import { ITheme } from '../../services/types';
import PopularThemeItem from './PopularThemeItem';

interface IProps extends BoxProps {
  themes: ITheme[];
  isEditing?: boolean;
  onOrderChange?: (themes: ITheme[]) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    overflow: 'auto',
    width: '100%',
    paddingBottom: 16,
  },
  scrollContentWrap: {
    display: 'flex',
    width: 'fit-content',
  },
}));

const SortableBox = sortableContainer((props: any) => {
  const { children } = props;
  const classes = useStyles();

  return <Box className={classes.scrollContentWrap}>{children}</Box>;
});

const SortablePopularThemeItem = sortableElement(PopularThemeItem);

const PopularThemeItemGraphicColors = [
  '#0c7fb3',
  '#5131a1',
  '#0052ab',
  '#328458',
  '#6c6625',
  '#a32f45',
  '#784930',
  '#365b80',
  '#8c3c3c',
  '#285c6b',
  '#843273',
];

export const PopularThemes = (props: IProps): JSX.Element => {
  const { themes, isEditing = false, onOrderChange, className } = props;
  const classes = useStyles();

  const handleSortEnd = ({ newIndex, oldIndex }: { newIndex: number; oldIndex: number }) => {
    if (!themes) {
      return;
    }

    const sorted = arrayMove([...themes], oldIndex - 1, newIndex - 1);
    sorted.forEach((t, i) => (t.order = i + 1));

    typeof onOrderChange === 'function' && onOrderChange(sorted);
  };

  return (
    <Box className={cx(classes.wrap, className)}>
      <SortableBox axis="x" lockAxis="x" onSortEnd={handleSortEnd}>
        {themes.map((theme, index) => (
          <SortablePopularThemeItem
            theme={theme}
            fill={PopularThemeItemGraphicColors[(PopularThemeItemGraphicColors.length % index) + 1]}
            key={theme.id}
            index={theme.order}
            disabled={!isEditing}
            isEditing={isEditing}
          />
        ))}
      </SortableBox>
    </Box>
  );
};
